<template>
<div id="form-container" ref="formContainer">
    <div id="pgTitle" tabindex="-1"><h1>Add Work Dates</h1></div>

    <form-wizard :stepSize="stepSize"
                 :nextButtonText="buttons.next"
                 :backButtonText="buttons.back"
                 :finishButtonText="buttons.submit"
                 color="#003865"
                 :layout="layout"
                 @on-complete="onSubmit"
                 id="wizard"
                 @on-change="switchTabs"
    >
        <span slot="title" tabindex="-1"/>

        <tab-content  title="Personal Information" :before-change="()=>validateStep('pi')" :after-change="()=>scrollTo()">
            <Contact ref="pi" @on-validate="mergePartialModels" :workDatesApplication="workDatesApplication"/>
        </tab-content>

        <tab-content  title="Address" :before-change="()=>validateStep('adr')" :after-change="()=>scrollTo()">
            <Address ref="adr" @on-validate="mergePartialModels" :workDatesApplication="workDatesApplication" />
        </tab-content>

        <tab-content  title="Work Dates" :before-change="()=>validateStep('wrk')" :after-change="()=>scrollTo()">
            <WorkDates ref="wrk" @on-validate="mergePartialModels" :workDatesApplication="workDatesApplication" />
        </tab-content>

        <tab-content title="Questionnaire"
                     :before-change="()=>validateStep('ques')" :after-change="()=>scrollTo()">
            <Question ref="ques" @on-validate="mergePartialModels" :technicianApplication="workDatesApplication"/>
        </tab-content>

        <tab-content title="Attachments"
                     :before-change="()=>validateStep('att')" :after-change="()=>scrollTo()">
            <Attachments ref="att" @on-validate="mergePartialModels" :app="workDatesApplication" v-bind:current="curAttachments"/>
        </tab-content>

        <tab-content title="Signature"
                     :before-change="()=>validateStep('sig')" :after-change="()=>scrollTo()">
            <Signature ref="sig"/>
        </tab-content>               
        
    </form-wizard>
</div>

</template>

<script>
import axios from "axios"
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
import { commonOptions } from '@/mixins/commonOptions.js'
import { buttons, breadcrumbs } from '@/mixins/constants.js'
import WorkDates from '@/components/add-work-dates-wizard/WorkDates.vue'
import Signature from '@/components/add-work-dates-wizard/Signature.vue'
import Address from '@/components/add-work-dates-wizard/Address.vue'
import Contact from '@/components/add-work-dates-wizard/Contact.vue'
import Attachments from '@/components/wizard/Attachments.vue'
import Question from '@/components/wizard/Question.vue'
import axiosRetry from 'axios-retry'


export default {
    components: {
        WorkDates,
        Signature,
        Attachments,
        Address,
        Contact,
        Question,
    },
    mixins: [
        commonOptions,
        breadcrumbs,
        buttons
    ],
    data() {
        return {            
            stepSize: 'sm',
            layout: '',
            isSubmitted: false,
            shortCode: '',            
            workDatesApplication: null,            
            isDisabled: false,
            curAttachments: []
        }
    },        
    created() {        
        if (this.$route.params.id) {
            this.loadApplication(this.$route.params.id)
        }
    },
    methods: {
        buttons: function() {
            return buttons
        },
        breadcrumbs: function() {
            return breadcrumbs
        },
        onSubmit() {
            if (!this.isDisabled) {
                this.isDisabled = true
                delete this.workDatesApplication.applyMethod
                this.sendToServer()
            }
        },
        sendToServer() {
            axiosRetry(axios, { retries: 0 })                      
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/work-dates`, this.workDatesApplication)
                    .then(response => {
                        this.isSubmitted = true
                        this.$router.push('/home')
            });
        },

        loadApplication(id) {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/application/${id}`)
                .then(response => {
                    this.$nextTick(() => {
                        this.workDatesApplication = response.data
                        this.workDatesApplication.license.licenseType = response.data.license.licenseType.code
                        this.workDatesApplication.questionResponses = []
                        if (!response.data.address || response.data.address.length === 0 ) {
                            this.workDatesApplication.address = [];
                        }
                        for(var i = 0; i < response.data.address.length; i++) {
                            this.workDatesApplication.address[i].addressType =
                                response.data.address[i]?.addressType?.code
                        }
                        axios.get(`${process.env.VUE_APP_API_BASE_URL}/Attachments/public/poaTypes`, { ignoreHeader: true })
                            .then(response => {
                                var poa = response.data
                                this.curAttachments = this.workDatesApplication.attachments.filter(a => a.type.code !== 'BP'
                                    && !poa.some(d => d.code === a.type.code))
                            })
                    });
                })
            },
        
        validateStep(name) {
            var refToValidate = this.$refs[name]
            return refToValidate.validate()
        },

        mergeCheck(model) {
            this.isCheck = model['isCheck']
        },

        mergePartialModels(model, isValid) {
            if(isValid){
                // merging each step model into the final model
                this.workDatesApplication = Object.assign({}, this.workDatesApplication, model)
                if (this.workDatesApplication.opts) {
                    delete this.workDatesApplication.opts
                }
            }
        },        

        scrollTo() {
            let elem = document.getElementById("wizard")
            elem.scrollIntoView()
        },

        focus(e) {
            let elem = document.getElementsByClassName("card-header")[e+1]
            elem.focus()
        },

        switchTabs(prevIdx, nextIdx) {
            var title = 'Welcome'
            switch (nextIdx) {
                case 0:
                    title = 'Personal Information'
                    break;
                case 1:
                    title = 'Address'
                    break;
                case 2:
                    title = 'Work Dates'
                    break;                
                case 3:
                    title = 'Attachments'
                    break;
                case 4:
                    title = 'Signature'
                    break;
                default:
                    title = 'Work Dates Information'
            }           
            document.getElementById('pgTitle').focus()
        },
        
        removeTabFocus() {
            this.$nextTick(function () {
                var steps = document.querySelectorAll("div[role='tab']")
                steps.forEach(step => {
                    step.setAttribute("tabindex", "-1")
                })

                var steps2 = document.querySelectorAll(".wizard-nav-pills>li>a");
                steps2.forEach(step => {
                    step.setAttribute("tabindex", "-1")
                    step.setAttribute("aria-disabled","true")
                })
            })
        },                
    },
    updated: function() {
        this.removeTabFocus()
    },
    mounted() {
        this.removeTabFocus()
    },
}
</script>

<style>
.card {
    margin-bottom: 18px;
}
.card-header {
    font-weight: 700;
}
</style>
